/* ============================================================
   Spotlight tile hover-shape preview override.

   The live settings come from the "Tile hover shape" section in
   Customize. This file does NOTHING unless a ?spotmorph=
   parameter is present - it must not touch data-spot-morph
   otherwise, or it would overwrite that section's choice.

     ?spotmorph=compare   panel: shape, size, colour, speed
     ?spotmorph=scallop   force one shape for this page load
     ?spotmorph=burst | star | clover | off

   Handy for trying a change before committing it in the theme
   editor, and for sending someone a link to one option. Delete
   the file and its script tag in layout/theme.liquid if that
   stops being useful - the section works without it.
   ============================================================ */

(function () {
  var SHAPES = ['off', 'burst', 'scallop', 'star', 'clover'];
  var LABELS = { off: 'Off', burst: 'Burst', scallop: 'Scallop', star: 'Star', clover: 'Clover' };
  var DEFAULT_COLOR = '#6b0015';
  var DEFAULT_SCALE = 86;
  var DEFAULT_SPEED = 450;
  var root = document.documentElement;

  var requested = '';
  try {
    requested = (new URLSearchParams(window.location.search).get('spotmorph') || '').toLowerCase();
  } catch (e) {
    return;
  }

  var showPanel = requested === 'compare';
  var shape = SHAPES.indexOf(requested) > -1 ? requested : showPanel ? 'scallop' : null;

  // No parameter: stand aside and let the theme section decide.
  if (shape === null) return;

  root.setAttribute('data-spot-morph', shape);
  if (!showPanel) return;

  function setShape(next) {
    root.setAttribute('data-spot-morph', next);
    var buttons = document.querySelectorAll('#spot-morph-compare [data-shape]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', buttons[i].dataset.shape === next ? 'true' : 'false');
    }
  }

  function setScale(pct) {
    root.style.setProperty('--spot-morph-scale', pct / 100);
    var out = document.getElementById('spot-morph-scale-out');
    if (out) out.textContent = pct + '%';
  }

  function setColor(hex) {
    root.style.setProperty('--spot-morph-backdrop', hex);
    var out = document.getElementById('spot-morph-color-out');
    if (out) out.textContent = hex.toUpperCase();
  }

  function setDuration(ms) {
    root.style.setProperty('--spot-morph-duration', ms + 'ms');
    var out = document.getElementById('spot-morph-duration-out');
    if (out) out.textContent = ms + 'ms';
  }

  function build() {
    var style = document.createElement('style');
    style.textContent = [
      '#spot-morph-compare{position:fixed;left:16px;bottom:16px;z-index:100000;',
      'font:13px/1.4 -apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;color:#111;',
      'background:#fff;border:1px solid #d5d5d5;border-radius:10px;padding:12px 14px;',
      'box-shadow:0 6px 24px rgba(0,0,0,.16);width:226px}',
      '#spot-morph-compare h4{margin:0 0 9px;font-size:11px;letter-spacing:.09em;',
      'text-transform:uppercase;color:#666;font-weight:600}',
      '#spot-morph-compare .row{display:flex;flex-wrap:wrap;gap:5px;margin-bottom:11px}',
      '#spot-morph-compare button{flex:1 0 40px;padding:6px 2px;font:inherit;font-size:12px;',
      'cursor:pointer;background:#f4f4f4;border:1px solid #d5d5d5;border-radius:6px;color:#111}',
      '#spot-morph-compare button[aria-pressed="true"]{background:#111;border-color:#111;color:#fff}',
      '#spot-morph-compare label{display:block;margin-bottom:9px;font-size:11px;color:#666}',
      '#spot-morph-compare label span{float:right;color:#111;font-variant-numeric:tabular-nums}',
      '#spot-morph-compare input[type=range]{width:100%;margin-top:5px;accent-color:#111}',
      '#spot-morph-compare input[type=color]{width:100%;height:30px;margin-top:5px;padding:0;',
      'border:1px solid #d5d5d5;border-radius:6px;background:none;cursor:pointer}',
      '#spot-morph-compare p{margin:2px 0 0;font-size:11px;color:#888}'
    ].join('');
    document.head.appendChild(style);

    var buttons = SHAPES.map(function (s) {
      return '<button type="button" data-shape="' + s + '">' + LABELS[s] + '</button>';
    }).join('');

    var panel = document.createElement('div');
    panel.id = 'spot-morph-compare';
    panel.innerHTML = [
      '<h4>Tile hover shape</h4>',
      '<div class="row">', buttons, '</div>',
      '<label>Shape size <span id="spot-morph-scale-out">', DEFAULT_SCALE, '%</span>',
      '<input id="spot-morph-scale" type="range" min="55" max="100" value="', DEFAULT_SCALE, '"></label>',
      '<label>Backdrop <span id="spot-morph-color-out">', DEFAULT_COLOR.toUpperCase(), '</span>',
      '<input id="spot-morph-color" type="color" value="', DEFAULT_COLOR, '"></label>',
      '<label>Speed <span id="spot-morph-duration-out">', DEFAULT_SPEED, 'ms</span>',
      '<input id="spot-morph-duration" type="range" min="150" max="900" step="25" value="', DEFAULT_SPEED, '"></label>',
      '<p>Preview only - set the real values in Customize.</p>'
    ].join('');
    document.body.appendChild(panel);

    panel.addEventListener('click', function (event) {
      var button = event.target.closest('[data-shape]');
      if (button) setShape(button.dataset.shape);
    });
    document.getElementById('spot-morph-scale').addEventListener('input', function (event) {
      setScale(Number(event.target.value));
    });
    document.getElementById('spot-morph-color').addEventListener('input', function (event) {
      setColor(event.target.value);
    });
    document.getElementById('spot-morph-duration').addEventListener('input', function (event) {
      setDuration(Number(event.target.value));
    });

    setShape(shape);
    setScale(DEFAULT_SCALE);
    setColor(DEFAULT_COLOR);
    setDuration(DEFAULT_SPEED);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
